module.exports = __webpack_public_path__ + "static/img/background_colored_paws_1200_983.cc5e1da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background_colored_paws_1200_983.jpg
// module id = WvCj
// module chunks = 0